import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_pa-3 _tac" }
const _hoisted_2 = { class: "_mt-0" }
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.Layout.WebPushUnaothorizedUserParagraph), 1 /* TEXT */),
    _createVNode(_component_base_button, {
      tag: "a",
      theme: "accent",
      size: "micro",
      class: "_mt-3 _ttl",
      href: _ctx.loginUrl
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Account.LogInButton), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href"]),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.Resources.Account.SignUpCallToActionIntroParagraph) + " ", 1 /* TEXT */),
      _createElementVNode("a", {
        class: "_tc--accent",
        href: _ctx.createAccountUrl
      }, _toDisplayString(_ctx.Resources.Comments.SignUpLink), 9 /* TEXT, PROPS */, _hoisted_3),
      _cache[0] || (_cache[0] = _createTextVNode(". ", -1 /* CACHED */))
    ])
  ]))
}